import { CodeItemService } from './../../common/services/codeitem.service';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';


@Component({
  selector: 'prg-select-command',
  templateUrl: './select-command.component.html',
  styleUrls: ['./select-command.component.css']
})
export class SelectCommandComponent implements OnInit {

  codeitem: Observable<any>;

  constructor(
    private store: Store<any>,
    private codeitemService: CodeItemService
  ) {
    this.codeitem = this.store.select(s => s.advancedProgramming.codeitem);
  }

  ngOnInit() {
  }

  categorySelected(event: any) {
    this.codeitemService.selectCategory(event.target.value);
  }

  deviceSelected(event: any) {
    this.codeitemService.selectDevice(event.target.value);
  }

  commandSelected(event: any) {
    this.codeitemService.selectCommand(event.target.value);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/select-command/select-command.component.ts